import React, { useEffect, useState } from 'react'
import { supabase } from './supabaseClient'

function App() {
  const [todos, setTodos] = useState([])
  const [newTitle, setNewTitle] = useState('')

  useEffect(() => {
    fetchTodos()
  }, [])

  async function fetchTodos() {
    try {
      const { data, error } = await supabase
        .from('todos')
        .select('*')
        .order('id', { ascending: true })

      if (error) throw error
      setTodos(data || [])
    } catch (error) {
      console.error('Error fetching todos:', error.message)
    }
  }

  async function addTodo(e) {
    e.preventDefault()
    if (!newTitle.trim()) return

    try {
      const { error } = await supabase
        .from('todos')
        .insert([{
          title: newTitle.trim(),
          is_complete: false
        }])

      if (error) throw error
      fetchTodos()
      setNewTitle('')
    } catch (error) {
      console.error('Error adding todo:', error.message)
    }
  }

  async function toggleComplete(todo) {
    try {
      const { error } = await supabase
        .from('todos')
        .update({ is_complete: !todo.is_complete })
        .eq('id', todo.id)

      if (error) throw error
      fetchTodos()
    } catch (error) {
      console.error('Error toggling todo:', error.message)
    }
  }

  async function deleteTodo(id) {
    try {
      const { error } = await supabase
        .from('todos')
        .delete()
        .eq('id', id)

      if (error) throw error
      fetchTodos()
    } catch (error) {
      console.error('Error deleting todo:', error.message)
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>TODO list</h1>

      { }
      <form onSubmit={addTodo} style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="New todo..."
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
        />
        <button type="submit">Add</button>
      </form>

      <ul>
        {todos.map((todo) => (
          <li key={todo.id} style={{ marginBottom: '8px' }}>
            <label style={{ marginRight: '10px' }}>
              <input
                type="checkbox"
                checked={!!todo.is_complete}
                onChange={() => toggleComplete(todo)}
              />
              <span style={{ marginLeft: '5px' }}>
                {todo.title} {todo.is_complete ? '✅' : '❌'}
              </span>
            </label>

            <button onClick={() => deleteTodo(todo.id)}>
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default App
